import PackagesAssociation from "../controllers/Settings/PackagesAssociation";

const packageAssociation = (path, navigation, exact, title, navByImportId = false) => ({
    path,
    navigation,
    component: PackagesAssociation,
    exact,
    navByImportId,
    title: [title],
});

export default packageAssociation;
